<template>
  <div>
    <v-list v-for="view in accessibleViews" :key="view.title" dense nav>

      <v-list-item v-if="mini" :class="miniListClass(view)">
        <v-icon small @click.stop="expandNavBarAndActivateGroup(view)">
          {{ view.icon }}
        </v-icon>
      </v-list-item>

      <v-list-item
        v-else-if="viewHasNoChildren(view)"
        :to="view.links[0].route"
        @click.stop="$emit('collapseNavBar')"
      >
        <v-icon small class="pr-2">
          {{ view.icon }}
        </v-icon>
        <v-list-item-title class="font-weight-bold">
          {{ view.title }}
        </v-list-item-title>
      </v-list-item>

      <v-list-group v-else :group="view.activeRouteMatcher">
        <template v-slot:activator>
          <v-icon small class="pr-2">
            {{ view.icon }}
          </v-icon>
          <v-list-item-title class="font-weight-bold" :id="view.title">
            {{ view.title }}
          </v-list-item-title>
        </template>
        <v-list-item
          v-for="(link, i) in view.links"
          :key="i"
          :to="link.route"
          activeClass="white--text"
          @click.stop="$emit('collapseNavBar')"
        >
          <v-list-item-title class="pl-6">
            {{ link.name }}
          </v-list-item-title>
        </v-list-item>
        <template v-slot:appendIcon>
          <v-icon class="pa-0 ma-0">
            mdi-menu-down
          </v-icon>
        </template>
      </v-list-group>

    </v-list>
  </div>
</template>

<script>
import { navBarViews } from '../views/config.js';

const DASHBOARD_TITLE = 'Dashboard';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    shouldShowDataManagement: {
      type: Boolean,
      default: false,
    },
    mini: Boolean,
    disabledLinks: Array,
  },
  computed: {
    accessibleViews() {
      const userAccessibleViews = navBarViews.filter(this.viewIsVisibleToUser);

      return this.removeDisabledLinksFromViews(userAccessibleViews);
    },
  },
  methods: {
    removeDisabledLinksFromViews(views = []) {
      if (views.length === 1 && views[0].title === DASHBOARD_TITLE) return [];

      return views.map(view => {
        const { links, title } = view;

        if (title === DASHBOARD_TITLE) {
          const enabledLinks = links.filter(link => !this.disabledLinks.includes(link.name));

          return { ...view, links: enabledLinks };
        }

        if (title === 'Internal' && !this.shouldShowDataManagement) {

          const internalLinks = links.filter(link => link.name !== 'Data Management');

          return { ...view, links: internalLinks };
        }

        return view;
      });
    },
    viewHasNoChildren(view) {
      return view.links && view.links.length === 1;
    },
    viewIsVisibleToUser(view) {
      if (!view) return false;

      const { roles = {} } = this.user;

      if (view.requiresMediaManager && !roles.MEDIA_MANAGER) return false;
      if (view.requiresCommerceEditor && !roles.COMMERCE_EDITOR) return false;

      return true;
    },
    miniListClass(view) {
      const containsCurrentLink = view.links.some(link => link.route === this.$route.path);

      return containsCurrentLink
        ? `mini-list v-list-item--active`
        : `mini-list`;
    },
    expandNavBarAndActivateGroup(view) {
      this.$emit('expandNavBar');

      const containsCurrentLink = view.links.some(link => link.route === this.$route.path);

      if (!containsCurrentLink) this.activateGroup(view.title);
    },
    activateGroup(title) {
      this.$nextTick(() => {
        const element = document.getElementById(title);

        if (element) element.click();
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-list-group__header__append-icon {
  min-width: auto !important;
}

::v-deep .v-list-item--active:before {
  background: rgb(0, 191, 189, 30) !important;
  z-index: -1;
}

::v-deep .v-list-item--active:hover:before {
  background: rgba(255, 255, 255, 0.4) !important;
}

.v-list-item__title {
  font-size: 14px !important;
}

::v-deep .mini-list.v-list-item--active:before {
  background: none !important;
}

::v-deep .mini-list.v-list-item--active>.v-icon:before {
  color: #00BFBD !important;
}
</style>
